import { WarningCircle } from '@phosphor-icons/react';

import * as Styled from './FormResultMessage.styles';
import type { FormResultMessageProps } from './FormResultMessage.styles';

const ErrorMessage = ({ marginTop, children, ...props }: FormResultMessageProps) => {
  return (
    <Styled.Container $marginTop={marginTop} $variant='error' data-cy='errorMessage' {...props}>
      <WarningCircle size={24} />
      {children}
    </Styled.Container>
  );
};

export default ErrorMessage;
